import { useMutation } from '@apollo/client';
import { DeleteAssetsAndFoldersMutation } from 'api/queries/creativeLibrary';
import { FolderId } from 'modules/domains/foldering';

type DeletedContent = {
  id: number;
  name: string;
};

type DeleteAssetContentAndFoldersResponse = {
  deleteAssetContentsAndFolders: {
    deletedContent: DeletedContent[];
    folderFailures: any[];
  };
};

type Variables = {
  contentIds: number[];
  folderIds: FolderId[];
};

export function useDeleteAssetsMutation() {
  const [mutate, { loading }] = useMutation<DeleteAssetContentAndFoldersResponse, Variables>(
    DeleteAssetsAndFoldersMutation,
  );

  return { mutate, isLoading: loading };
}
